export enum UserPasswordExpireStatus {
    Ok = 'ok',
    ExpireSoon = 'expire_soon',
    Expired = 'expired'
}